import decode from 'jwt-decode';

const KEY = 'token';

let _token = null;

export function setToken(token) {
  if (token) {
    _token = token;
    localStorage.setItem(KEY, token);
  } else {
    clearToken();
  }
}

export function getToken() {
  return _token || localStorage.getItem(KEY);
}

export function clearToken() {
  _token = null;
  localStorage.removeItem(KEY);
}

export function decodeToken(token) {
  return decode(token);
}



// WEBPACK FOOTER //
// ./app/helpers/auth.js